import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { PagedCollectionQueryResultDTO } from '@skylab-shared/business';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';

export type PurchaseJpkVatGroupCollectionItem = PurchaseJpkVatGroupCollectionItemDTO;

class PurchaseJpkVatGroupCollectionItemDTO {
    public readonly code: string;
    public readonly description: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly activeFrom?: Date;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly activeTo?: Date;
    public readonly orderBy: number;
}

export class PurchaseJpkVatGroupCollectionQuery extends Query<PurchaseJpkVatGroupCollectionItem[]> { }

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseJpkVatGroupCollectionQuery)
export class PurchaseJpkVatGroupCollectionQueryHandler implements QueryHandler<PurchaseJpkVatGroupCollectionQuery, PurchaseJpkVatGroupCollectionItem[]> {
    #Url = TaggedUrl.join('purchase/jpkVatGroups', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(_: PurchaseJpkVatGroupCollectionQuery): Promise<PurchaseJpkVatGroupCollectionItem[]> {
        const { data } = await this.#http.get(this.#Url, {
            dtoObject: new PagedCollectionQueryResultDTO<PurchaseJpkVatGroupCollectionItemDTO>(PurchaseJpkVatGroupCollectionItemDTO)
        });

        return data.items.sort((a, b) => a.orderBy === b.orderBy ? 0 : a.orderBy < b.orderBy ? -1 : 1).map(item => ({
            code: item.code,
            description: item.description,
            activeFrom: item.activeFrom,
            activeTo: item.activeTo,
            orderBy: item.orderBy
        }));
    }
}
